const DISPLACEMENT_REASONS = new Set(["displaced_by_new_login", "refresh_replay"]);
const REVOCATION_REASONS = new Set(["invalid_or_revoked_session", "session_revoked"]);

export const IDLE_TIMEOUT_MESSAGE =
  "Your session timed out due to inactivity. Please sign in again.";
export const SILENT_SESSION_END_KEY = "auth_end_silent";

export const getSessionEndMessage = (reason) => {
  if (reason === "idle_timeout") {
    return IDLE_TIMEOUT_MESSAGE;
  }
  if (DISPLACEMENT_REASONS.has(reason)) {
    return "Your session ended because this account was signed in elsewhere.";
  }
  if (REVOCATION_REASONS.has(reason)) {
    return "Your session is no longer valid. Please sign in again.";
  }
  if (reason === "password_reset") {
    return "Your password was reset. Please sign in with your new password.";
  }
  return null;
};
